import React from "react"
import styled, {css} from "styled-components"

import Flex from "@irati/ui/src/Flex"

export const Label = styled.label`
  margin: 0;
`

export const Container = styled((props) => <Flex {...props} />)`
  cursor: pointer;
  border-bottom: 1px solid ${({theme}) => theme.colors.primary2_50};
  ${({theme}) => css`
    padding: ${theme.spacing.two} 0;
    &:hover {
      background: ${theme.colors.primary2_50};
    }
  `}
  span {
    cursor: pointer;
  }
  ${({theme}) => theme.mediaQueries.minWidthMedia.desktop`
    border-color: transparent;
  `}
`
